import { apiFetch, Code, FetchReturn } from "../../lib/utils";

export interface TEmails {
    Id: number;
}

const escapeHtml = (unsafe: string) => {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
};

const ReviewEndpoint = "/Emails";
// const Get = async (): Promise<TEmails
// []> => {
//     const response = await apiFetch(ReviewEndpoint);
//     const reviews = await response.json();
//     return reviews;
// }

// // const Post = async (review: TEmails
// ): Promise<FetchReturn<TEmails
// >> => {
//     //     try {
//         const result = await apiFetch(ReviewEndpoint, "POST", { ...review });
//         //return created object instead of local object
//         return { Code: Code.OK, Message: "Success", Content: review }
//     } catch (error) {
//         return { Code: Code.ADD_ERR, Message: "Något gick fel, kunde inte skapa granskning", Content: review };
//     }
// }

const sendTestEmail = async (subject: string, body: string): Promise<any> => {
    try {
        const escapedBody = escapeHtml(body); // Escape the body content

        const response = await apiFetch(`${ReviewEndpoint}/api/send-test-to-user/`, "POST", JSON.stringify({
            Subject: subject,
            Body: escapedBody,
        }));

        const contentType = response.headers.get("content-type");
        let result;

        if (contentType && contentType.includes("application/json")) {
            result = await response.json();  // Parse as JSON
        } else {
            result = { Message: await response.text() };  // Parse as plain text
        }

        if (!response.ok) {
            throw new Error(result.Message || "Failed to send test email");
        }

        return result.Message || "Test email sent successfully.";  // Return the message for handling in the UI

    } catch (error) {
        console.error('Error sending test email:', error);
        throw error;  // Propagate error to be handled in the calling function
    }
};


const sendEmails = async (request: any): Promise<void> => {
    try {
        const escapedBody = escapeHtml(request.Body);  // Escape the body content to avoid XSS issues

        // Perform API call to send emails
        const response = await apiFetch(`${ReviewEndpoint}/send-emails`, "POST", JSON.stringify({
            Subject: request.Subject,                 // Email subject
            Body: escapedBody,                        // Escaped email body
            SupplierOrgNr: request.SupplierOrgNr,     // Supplier's organization number
            SupplierName: request.SupplierName,       // Supplier's name
            Period: request.Period,                   // Start period (formatted startDate)
            EndPeriod: request.EndPeriod,             // End period (formatted endDate)
            EmailTemplateId: request.EmailTemplateId, // Email template ID
            Members: request.Members                  // List of members (orgNr, email)
        }));


        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Error ${response.status}: ${errorText}`);
        }

        const contentType = response.headers.get("content-type");
        let result;
        if (contentType && contentType.includes("application/json")) {
            result = await response.json();
        } else {
            result = { Message: await response.text() };
        }
    } catch (error) {
        console.error('Error sending emails:', error);
        throw error;
    }
};

const reopenLink = async (sendingId: number): Promise<string> => {
    try {
        // Perform API call to reopen the link using PUT
        const response = await apiFetch(`${ReviewEndpoint}/api/reopen-link/${sendingId}`, "PUT");

        // If the response is not OK, check the status code directly
        if (!response.ok) {
            if (response.status === 400) {
                // Handle the specific case where the backend returned Bad Request (e.g., link already open)
                throw new Error("Länken är fortfarande aktiv.");
            } else {
                // Handle any other non-OK status
                throw new Error("Misslyckades med att återöppna länken.");
            }
        }

        // If the response is OK, parse the message as normal
        const contentType = response.headers.get("content-type");
        let result;

        if (contentType && contentType.includes("application/json")) {
            result = await response.json();  // Parse as JSON
        } else {
            result = { Message: await response.text() };  // Parse as plain text
        }

        // Return the success message from the backend
        return result.Message || "Länken har öppnats på nytt och förfallodatumet har uppdaterats.";

    } catch (error: any) {
        // Log the error for debugging purposes
        console.error('Error reopening the link:', error.status);

        // Return the error message to the UI for display
        if (error.status === 400) {
            throw new Error("Länken är fortfarande aktiv.");
        }

        // Return a generic fallback message in case of unknown errors
        throw new Error("Ett okänt fel inträffade.");
    }
};

export {
    // Get,
    // Post,
    sendTestEmail,
    sendEmails,
    reopenLink
}